export default function PropertyTypesSection() {
  const propertyTypes = [
    {
      title: 'Single-Family Rentals',
      description: 'We buy single-family homes with tenants in place. Whether you have long-term tenants or month-to-month occupants, we can purchase your rental property quickly.',
      image: 'https://public.readdy.ai/ai/img_res/b6a7a335892066ceee710fc363a66cbe.jpg'
    },
    {
      title: 'Duplexes & Triplexes',
      description: 'Sell your duplex or triplex with tenants still living there. We handle multi-unit properties with multiple lease agreements and different tenant situations.',
      image: 'https://readdy.ai/api/search-image?query=duplex%20triplex%20multi-family%20rental%20property%20with%20two%20or%20three%20units%20tenant%20occupied%20building%20residential%20investment%20real%20estate%20side%20by%20side%20units&width=600&height=400&seq=rental-type-002&orientation=landscape'
    },
    {
      title: 'Small Apartment Buildings',
      description: 'We purchase 4-20 unit apartment buildings with existing tenants. Our experience with larger properties ensures smooth transitions for all occupants.',
      image: 'https://readdy.ai/api/search-image?query=small%20apartment%20building%20complex%20with%20multiple%20rental%20units%20tenant%20occupied%20multi-family%20property%20residential%20investment%20building%20modern%20architecture&width=600&height=400&seq=rental-type-003&orientation=landscape'
    },
    {
      title: 'Fourplexes & Quads',
      description: 'Fourplex properties with tenants are our specialty. We buy these popular investment properties in any condition with any tenant mix.',
      image: 'https://readdy.ai/api/search-image?query=fourplex%20quad%20rental%20property%20four%20unit%20residential%20building%20tenant%20occupied%20investment%20property%20multiple%20entrances%20modern%20multi-family%20design&width=600&height=400&seq=rental-type-004&orientation=landscape'
    },
    {
      title: 'Mixed-Use Properties',
      description: 'We buy mixed-use buildings with both commercial and residential tenants. These complex properties require specialized expertise we possess.',
      image: 'https://readdy.ai/api/search-image?query=mixed%20use%20building%20with%20commercial%20retail%20ground%20floor%20and%20residential%20apartments%20above%20tenant%20occupied%20urban%20property%20investment%20real%20estate&width=600&height=400&seq=rental-type-005&orientation=landscape'
    },
    {
      title: 'Townhouse Rentals',
      description: 'Sell your tenant occupied townhouses to us. Whether you own one unit or multiple townhomes, we can make competitive cash offers.',
      image: 'https://readdy.ai/api/search-image?query=townhouse%20rental%20property%20row%20houses%20tenant%20occupied%20residential%20units%20modern%20townhome%20community%20investment%20property%20connected%20units&width=600&height=400&seq=rental-type-006&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Types of Tenant Occupied Properties We Buy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We purchase all types of rental property with tenants in place throughout El Paso. No property is too small or too large for our team.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {propertyTypes.map((type, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative w-full h-64">
                <img 
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{type.title}</h3>
                <p className="text-gray-600 leading-relaxed">{type.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Don't See Your Property Type Listed?</h3>
          <p className="text-xl text-teal-100 mb-8 max-w-2xl mx-auto">
            We buy all types of tenant occupied real estate. Call us today to discuss your specific property and situation.
          </p>
          <a 
            href="tel:+1-915-206-5814"
            className="inline-flex items-center bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814 Now
          </a>
        </div>
      </div>
    </section>
  );
}